import Routes from "./routes";
import ContextProvider from "./store/appContext";
import reducer, { initialState } from "./store/reducers";
import { AuthProvider } from "./utils/authProvider";
import TagManager from 'react-gtm-module';
import  config  from '../src/config/config'
import { Amplify } from 'aws-amplify';
import { Helmet } from "react-helmet";
import { getCarrierByDomain, getThemeByCarrier } from "./domain";
import useFetchConfig from "./hooks/useFetchConfig";
import { useEffect, useState } from "react";

const Config = config
const GTMID = Config?.SSO?.GTM_ID
const tagManagerArgs = {
  gtmId: GTMID
}

const oauth = {
  domain: Config.cognito.domain,
  scope: [],
  responseType: 'token'
};

Amplify.configure({
  Auth: {
    oauth: oauth,
    region: Config.cognito.region,
    userPoolId: Config.cognito.userPoolId,
    userPoolWebClientId: Config.cognito.userPoolWebClientId,
    authenticationFlowType: 'CUSTOM_AUTH'
  },
});

function App() {
  TagManager.initialize(tagManagerArgs)
  // let carrier = getCarrierByDomain()
  let themeData = getThemeByCarrier();
  // const [_theme] = useFetchConfig(carrier, themeData)
  // const { theme } = _theme
  const [title, setTitle] = useState(null)

  useEffect(() => {
    if(themeData) {
      setTitle(themeData?.program)
      document.getElementById('favicon')?.setAttribute('href', themeData?.theme?.favicon)
    }
  }, [themeData]);

  

  return (
    <>
    <Helmet>
    <title>{title ? title : "No title"}</title>
  </Helmet>
    <ContextProvider initialState={initialState} reducer={reducer}>
        <AuthProvider>
          <Routes />
        </AuthProvider>
    </ContextProvider>
    </>
  );
}

export default App;
